export const emptySupplier = {
  legalName: '',
  displayName: '',
  category: '',
  ownerName: '',
  reaNumber: '',
  referredBy: '',
  sector: '',
  legalForm: '',
  vatNumber: '',
  taxCode: '',
  registeredAddress: '',
  companyEmail: '',
  companyPhone: '',
  contactName: '',
  contactRole: '',
  contactEmail: '',
  contactPhone: '',
  status: 'ACTIVE',
  notes: '',
  customFields: {},
};
